<template>
  <div class="organization-finding-target-view">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="card-title">{{ $t("finding.target.title") }}</h4>
          <button v-if="!target" class="btn btn-primary" @click="openForm"><i class="bx bx-plus"></i> {{ $t("finding.target.create") }}</button>
          <button v-else class="btn btn-primary" @click="openForm"><i class="bx bx-edit"></i> {{ $t("finding.target.edit") }}</button>
        </div>

        <div v-if="target">
          <div class="row mb-3">
            <div class="col-md-6">
              <strong>{{ $t("finding.target.extensionRequestCount") }}:</strong> {{ target.extensionRequestCount }}
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>{{ $t("finding.target.criticality") }}</th>
                  <th>{{ $t("finding.target.description") }}</th>
                  <th>{{ $t("finding.target.approval-duration") }}</th>
                  <th>{{ $t("finding.target.resolution-duration") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="key in ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL']" :key="key">
                  <td>{{ $t("audit-control.criticality." + key.toLowerCase()) }}</td>
                  <td>
                    <span v-if="target.criticality && target.criticality[key] && target.criticality[key].description">{{ target.criticality[key].description | translate }}</span>
                  </td>
                  <td>
                    <span v-if="target.criticality && target.criticality[key] && target.criticality[key].approvalDuration && target.criticality[key].approvalDuration.value">
                      {{ target.criticality[key].approvalDuration.value }} {{ $t("audit-control.unit." + target.criticality[key].approvalDuration.unit.toLowerCase()) }}
                    </span>
                  </td>
                  <td>
                    <span v-if="target.criticality && target.criticality[key] && target.criticality[key].resolutionDuration && target.criticality[key].resolutionDuration.value">
                      {{ target.criticality[key].resolutionDuration.value }} {{ $t("audit-control.unit." + target.criticality[key].resolutionDuration.unit.toLowerCase()) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else class="text-center p-5">
          <p>{{ $t("finding.target.no-data") }}</p>
          <p class="text-muted">{{ $t("finding.target.description-hint") }}</p>
        </div>
      </div>
    </div>
    <right-panel id="sidebar-new-target" width="1000px" @hidden="rightPanelClosed" :text="$t('audit-control.control.new')">
      <div class="pl-5 pr-5">
        <organization-finding-target-form />
      </div>
    </right-panel>
  </div>
</template>

<script>
import OrganizationFindingTargetForm from "./organization-finding-target-form";

export default {
  components: { OrganizationFindingTargetForm },
  data() {
    return {};
  },
  computed: {
    target() {
      return this.$store.getters["organizationFindingTarget/selectedEntity"];
    },
  },
  mounted() {
    this.fetchTarget();
  },
  methods: {
    fetchTarget() {
      this.$store.dispatch("organizationFindingTarget/fetchTarget");
    },
    openForm() {
      this.$store.commit("organizationFindingTarget/editedEntity", this.target);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-target");
    },
    rightPanelClosed() {
      this.fetchTarget();
    },
  },
};
</script>
